/**
 *  @class
 *  @function ImageText
 */

if (!customElements.get('read-more-section')) {
  class ReadMoreSection extends HTMLElement {
    constructor() {
      super();
      this.hasOverflow = false; // Track of de tekst ooit is afgekapt
    }

    connectedCallback() {
      const readMoreBtn = this.querySelector('.read-more-btn');
      const textContent = this.querySelector('.text-content');

      // Functie om te checken of de tekst wordt afgekapt
      const checkTextOverflow = () => {
        const isOverflowing = textContent.scrollHeight > textContent.clientHeight;
        if (isOverflowing) {
          this.hasOverflow = true; // Markeer dat er overflow was
        }

        // Alleen verbergen als er geen overflow is EN de tekst niet is uitgeklapt
        if (!this.hasOverflow || textContent.classList.contains('expanded')) {
          readMoreBtn.style.display = this.hasOverflow ? 'block' : 'none';
        } else {
          readMoreBtn.style.display = isOverflowing ? 'block' : 'none';
        }
      };

      // Initial check
      checkTextOverflow();

      // ResizeObserver voor dynamische updates
      const resizeObserver = new ResizeObserver(() => {
        if (!textContent.classList.contains('expanded')) {
          checkTextOverflow(); // Alleen checken als tekst niet is uitgeklapt
        }
      });

      // Observeer het tekst-element
      resizeObserver.observe(textContent);

      // Klik-handler voor de knop
      readMoreBtn.addEventListener('click', () => {
        textContent.classList.toggle('expanded');
        readMoreBtn.textContent = textContent.classList.contains('expanded')
          ? 'Lees minder'
          : 'Lees meer';

        // Knop blijft zichtbaar als er ooit overflow was
        if (this.hasOverflow) {
          readMoreBtn.style.display = 'block';
        }
      });
    }
  }
  customElements.define('read-more-section', ReadMoreSection);
}